<template>

    <div class="col-12">

        <div class="card-grid">
            <div class="card with-padding with-shadow details">
                <div class="d-flex justify-content-between align-items-baseline">
                    <h2 class="title">
                        {{ product.scheme_card_main_driver_heading_text }}
                        <span v-if="profile.mainDriver" class="badge badge-secondary">Main Driver</span>
                    </h2>
                    <a href="#" aria-label="Edit" @click.prevent="editProfile()">Edit</a>
                </div>
                <ul>
                    <li class="d-block"><span class="key d-block">Name:</span><span class="value d-block">{{ profile.fullName }}</span></li>
                    <li class="d-block"><span class="key d-block">Email Address:</span><span class="value d-block">{{ profile.emailAddress }}</span></li>
                    <li class="d-block"><span class="key d-block">Date of Birth:</span><span class="value d-block">{{ formatIsoDate(profile.dateOfBirth) }}</span></li>
                    <li class="d-block"><span class="key d-block">Driving License #:</span><span class="value d-block">{{ driverLicense(profile) }}</span></li>
                    <li class="d-block"><span class="key d-block">Postcode:</span><span class="value d-block">{{ profile.postcode }}</span></li>
                </ul>
                <h3 class="insurance-heading">Insurance Questions</h3>
                <ul>
                    <li class="d-block">
                        <span class="key d-block">Is the driver a permanent UK resident?</span>
                        <span class="value d-block">{{ profile.insuranceQuestions ? profile.insuranceQuestions['Is the driver a permanent UK resident'] : '' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document?</span>
                        <span class="value d-block">{{ profile.insuranceQuestions ? profile.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] : '' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS?</span>
                        <span class="value d-block">{{ profile.insuranceQuestions ? profile.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] : '' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT?</span>
                        <span class="value d-block">{{ profile.insuranceQuestions ? profile.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] : '' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver received any conviction which has resulted in a driving ban in the last 5 years?</span>
                        <span class="value d-block">{{ profile.insuranceQuestions ? profile.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] : '' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver had more than 1 FAULT claim in the last 3 years?</span>
                        <span class="value d-block">{{ profile.insuranceQuestions ? profile.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years'] : '' }}&nbsp;</span>
                    </li>
                </ul>
                <div v-if="invalidInsuranceQuestionAnswers(profile.insuranceQuestions)" class="invalid-insurance-answers">
                    <template v-if="profile.mainDriver">
                        Unfortunately due to the answer/s you have provided we are unable to proceed. Please contact the team using the contact details on the side bar. It maybe possible that we can refer your details to the insurer. Please note there is no guarantee that the insurer will accept your circumstances, however if they can, an additional premium or surplus excess amount may be applicable.
                    </template>
                    <template v-else>
                        Unfortunately due to the answer/s you have provided for this additional driver we are unable to proceed. Please consider removing this driver to continue or contact the team using the contact details on the side bar to discuss. It may be possible that we can refer the details to the insurer. Please note there is no guarantee that the insurer will accept the additional drivers circumstances, however if they can, an additional premium or surplus excess amount may be applicable.
                    </template>
                </div>
            </div>

            <div class="card with-padding with-shadow details" v-for="additionalDriver, key in profile.additionalDrivers">
                <div class="d-flex justify-content-between align-items-baseline">
                    <h2 class="title">
                        {{ key === 0 ? product.scheme_card_additional_driver_one_heading_text : product.scheme_card_additional_driver_two_heading_text }}
                        <span v-if="additionalDriver.mainDriver" class="badge badge-secondary">Main Driver</span></h2>
                    <a href="#" aria-label="Edit" @click.prevent="showExistingAdditionalDriverForm(key)">Edit</a>
                </div>
                <ul>
                    <li class="d-block"><span class="key d-block">Name:</span><span class="value d-block">{{ additionalDriver.fullName }}</span></li>
                    <li class="d-block"><span class="key d-block">Email Address:</span><span class="value d-block">{{ additionalDriver.emailAddress }}</span></li>
                    <li class="d-block"><span class="key d-block">Date of Birth:</span><span class="value d-block">{{ formatIsoDate(additionalDriver.dateOfBirth) || 'Not provided' }}</span></li>
                    <li class="d-block"><span class="key d-block">Driving License #:</span><span class="value d-block">{{ driverLicense(additionalDriver) }}</span></li>
                    <li class="d-block"><span class="key d-block">Postcode:</span><span class="value d-block">{{ additionalDriver.postcode || 'Not provided' }}</span></li>
                </ul>
                <h3 class="insurance-heading">Insurance Questions</h3>
                <ul>
                    <li class="d-block">
                        <span class="key d-block">Is the driver a permanent UK resident?</span>
                        <span class="value d-block">{{ additionalDriver.insuranceQuestions ? additionalDriver.insuranceQuestions['Is the driver a permanent UK resident'] : 'Answer not provided' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document?</span>
                        <span class="value d-block">{{ additionalDriver.insuranceQuestions ? additionalDriver.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] : 'Answer not provided' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS?</span>
                        <span class="value d-block">{{ additionalDriver.insuranceQuestions ? additionalDriver.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] : 'Answer not provided' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT?</span>
                        <span class="value d-block">{{ additionalDriver.insuranceQuestions ? additionalDriver.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] : 'Answer not provided' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver received any conviction which has resulted in a driving ban in the last 5 years?</span>
                        <span class="value d-block">{{ additionalDriver.insuranceQuestions ? additionalDriver.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] : 'Answer not provided' }}&nbsp;</span>
                    </li>
                    <li class="d-block">
                        <span class="key d-block">Has the driver had more than 1 FAULT claim in the last 3 years?</span>
                        <span class="value d-block">{{ additionalDriver.insuranceQuestions ? additionalDriver.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years'] : 'Answer not provided' }}&nbsp;</span>
                    </li>
                </ul>
                <div v-if="invalidInsuranceQuestionAnswers(additionalDriver.insuranceQuestions)" class="invalid-insurance-answers">
                    <template v-if="profile.mainDriver">
                        Unfortunately due to the answer/s you have provided we are unable to proceed. Please contact the team using the contact details on the side bar. It maybe possible that we can refer your details to the insurer. Please note there is no guarantee that the insurer will accept your circumstances, however if they can, an additional premium or surplus excess amount may be applicable.
                    </template>
                    <template v-else>
                        Unfortunately due to the answer/s you have provided for this additional driver we are unable to proceed. Please consider removing this driver to continue or contact the team using the contact details on the side bar to discuss. It may be possible that we can refer the details to the insurer. Please note there is no guarantee that the insurer will accept the additional drivers circumstances, however if they can, an additional premium or surplus excess amount may be applicable.
                    </template>
                </div>
            </div>

            <div class="card details d-flex justify-content-center" v-if="profile.additionalDrivers && (profile.additionalDrivers.length < maxAdditionalDrivers)">
                <a href="" aria-label="Add additional driver" class="add-additional-driver align-self-center" @click.prevent="showNewAdditionalDriverForm">
                    <div class="add-symbol">＋</div>
                    {{ product.scheme_card_additional_driver_action_text }}
                </a>
            </div>

        </div>

        <div class="card-grid">
            <div class="card with-padding with-shadow details card--span-2">
                <h2 class="title">{{ product.scheme_card_insurance_criteria_heading_text }}</h2>
                <div class="row">
                    <div class="col-6">
                        <div class="custom-multiselect mb-2">
                            <label for="insurance-overnight">Where is the vehicle to be primarily kept overnight?</label>
                            <multiselect
                                id="insurance-overnight"
                                v-model="primaryOvernightVehicleLocation.selected"
                                placeholder=""
                                :multiple="false"
                                :options="primaryOvernightVehicleLocation.options"
                                @select="changePrimaryOvernightVehicleLocation"
                            >
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="agree">
                    <input type="checkbox" name="confirm" id="confirm" class="confirm" @change="toggleAcceptanceOfSalarySacrificeConditionsOfUseAndInsurance" :checked="profile.acceptanceOfSalarySacrificeConditionsOfUseAndInsurance">
                    <label for="confirm">{{ product.scheme_card_insurance_declaration_text }}</label>
                </div>
            </div>
        </div>


        <div class="slideout"
             :class="{ 'slideout--show' : slideoutVisible }">

            <div v-if="slideoutVisible">

                <!-- Header -->
                <div class="row">
                    <div class="col-10 text-start">
                        <div>
                            <h3><span>{{ additionalDriverTitle }}</span></h3>

                            <form method="POST" @submit.prevent="submitAdditionalDriverForm" id="edit-additional-driver-form">

                                <input v-if="payload.additionalDriverID" type="hidden" name="additional_driver_id" v-model="payload.additionalDriverID">

                                <h6>Name:</h6>

                                <div class="row mb-4">
                                    <div class="col-6">
                                        <div class="input firstname">
                                            <input type="text" class="firstname" name="firstname" id="additional-driver-firstname" v-model="payload.firstname" required>
                                            <label for="additional-driver-firstname">Firstname</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="input surname">
                                            <input type="text" class="surname" name="surname" id="additional-driver-surname" v-model="payload.surname" required>
                                            <label for="additional-driver-surname">Surname</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <div class="input email">
                                            <input type="email" class="email" name="email" id="additional-driver-email" v-model="payload.email" required>
                                            <label for="additional-driver-email">Additional Driver Email</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <div class="lightswitch lightswitch-left">
                                            <input type="checkbox" name="main_driver" id="additional-driver-main-driver" class="main-driver" v-model="payload.mainDriver">
                                            <label for="additional-driver-main-driver">Set as Main Driver</label>
                                        </div>
                                    </div>
                                </div>

                                <h6>Date of Birth:</h6>

                                <div class="row mb-3">
                                    <div class="col-6">
                                        <div class="custom-multiselect">
                                            <label for="additional-driver-dob-month">Month</label>
                                            <multiselect
                                                id="additional-driver-dob-month"
                                                v-model="payload.dob.month"
                                                :options="months"
                                                :show-labels="false"
                                            >
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="custom-multiselect">
                                            <label for="additional-driver-dob-day">Day</label>
                                            <multiselect
                                                id="additional-driver-dob-day"
                                                v-model="payload.dob.day"
                                                :options="daysInMonth(payload.dob.month, payload.dob.year)"
                                                :show-labels="false"
                                            >
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="custom-multiselect">
                                            <label for="additional-driver-dob-year">Year</label>
                                            <multiselect
                                                id="additional-driver-dob-year"
                                                v-model="payload.dob.year"
                                                :options="years()"
                                                :show-labels="false"
                                            >
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <div class="input postcode">
                                            <input type="text" class="postcode" name="postcode" id="additional-driver-postcode" v-model="payload.postcode" required>
                                            <label for="additional-driver-postcode">Postcode</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <div class="input driving-license">
                                            <input type="text" class="driving-license" name="driving_license" id="additional-driver-driving-license" v-model="payload.drivingLicense" required>
                                            <label for="additional-driver-driving-license">Driving License #:</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <label class="d-block">Is the driver a permanent UK resident?</label>
                                        <input type="radio" name="points" id="additional-driver-permanent-uk-resident-yes" value="Yes" v-model="payload.insuranceQuestions['Is the driver a permanent UK resident']" required>
                                        <label for="additional-driver-permanent-uk-resident-yes" class="me-4"><b>Yes</b></label>
                                        <input type="radio" name="points" id="additional-driver-permanent-uk-resident-no" value="No" v-model="payload.insuranceQuestions['Is the driver a permanent UK resident']" required>
                                        <label for="additional-driver-permanent-uk-resident-no" class="me-4"><b>No</b></label>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <label class="d-block">Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document?</label>
                                        <input type="radio" name="full-valid-license" id="additional-driver-full-valid-license-yes" value="Yes" v-model="payload.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']" required>
                                        <label for="additional-driver-full-valid-license-yes" class="me-4"><b>Yes</b></label>
                                        <input type="radio" name="full-valid-license" id="additional-driver-full-valid-license-no" value="No" v-model="payload.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']" required>
                                        <label for="additional-driver-full-valid-license-no" class="me-4"><b>No</b></label>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <label class="d-block">Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS?</label>
                                        <input type="radio" name="convictions" id="additional-driver-convictions-yes" value="Yes" v-model="payload.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']" required>
                                        <label for="additional-driver-convictions-yes" class="me-4"><b>Yes</b></label>
                                        <input type="radio" name="convictions" id="additional-driver-convictions-no" value="No" v-model="payload.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']" required>
                                        <label for="additional-driver-convictions-no" class="me-4"><b>No</b></label>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <label class="d-block">Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT?</label>
                                        <input type="radio" name="convictions-other" id="additional-driver-convictions-other-yes" value="Yes" v-model="payload.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']" required>
                                        <label for="additional-driver-convictions-other-yes" class="me-4"><b>Yes</b></label>
                                        <input type="radio" name="convictions-other" id="additional-driver-convictions-other-no" value="No" v-model="payload.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']" required>
                                        <label for="additional-driver-convictions-other-no" class="me-4"><b>No</b></label>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <label class="d-block">Has the driver received any conviction which has resulted in a driving ban in the last 5 years?</label>
                                        <input type="radio" name="ban" id="additional-driver-ban-yes" value="Yes" v-model="payload.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']" required>
                                        <label for="additional-driver-ban-yes" class="me-4"><b>Yes</b></label>
                                        <input type="radio" name="ban" id="additional-driver-ban-no" value="No" v-model="payload.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']" required>
                                        <label for="additional-driver-ban-no" class="me-4"><b>No</b></label>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col-12">
                                        <label class="d-block">Has the driver had more than 1 FAULT claim in the last 3 years?</label>
                                        <input type="radio" name="faults" id="additional-driver-faults-yes" value="Yes" v-model="payload.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years']" required>
                                        <label for="additional-driver-faults-yes" class="me-4"><b>Yes</b></label>
                                        <input type="radio" name="faults" id="additional-driver-faults-no" value="No" v-model="payload.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years']" required>
                                        <label for="additional-driver-faults-no" class="me-4"><b>No</b></label>
                                    </div>
                                </div>

                                <input type="submit" value="Save" class="button button--steelBlue float-end">
                                <button v-if="payload.additionalDriverID" class="button button--remove float-end me-2" @click.prevent="deleteAdditionalDriver">Delete Driver</button>

                            </form>
                        </div>
                    </div>
                    <div class="col-2 text-end">
                        <button @click="hideSlideout" class="close"><i class="icon-cross"></i></button>
                    </div>
                </div>

            </div>

        </div>
    </div>

</template>

<script>

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

import {EventBus} from '@/event-bus.js';
import Multiselect from 'vue-multiselect'

export default {
    name: 'salsac-your-profile-scheme-details-component',
    data() {
        return {
            primaryOvernightVehicleLocation: {
                options: [],
                selected: null
            },
            slideoutVisible: false,
            payload: {
                additionalDriverID: null,
                firstname: null,
                surname: null,
                email: null,
                mainDriver: null,
                postcode: null,
                dob: this.getDateOfBirth(),
                drivingLicense: null,
                insuranceQuestions: {
                    'Is the driver a permanent UK resident': null,
                    'Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document': null,
                    'Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS': null,
                    'Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT': null,
                    'Has the driver received any conviction which has resulted in a driving ban in the last 5 years': null,
                    'Has the driver had more than 1 FAULT claim in the last 3 years': null
                },
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ]
        }
    },

    mounted() {
        this.getPrimaryOvernightVehicleLocationOptionsAndSetSelected();

        EventBus.$on('yourProfileCompleted', (profileCompleted) => {
            this.getPrimaryOvernightVehicleLocationOptionsAndSetSelected();
        });
    },

    computed: {
        additionalDriverTitle() {
            if (this.payload.additionalDriverID) {
                let index = 0;
                this.profile.additionalDrivers.forEach((additionalDriver, idx) => {
                    if (additionalDriver.id === this.payload.additionalDriverID) {
                        index = idx;
                    }
                });
                return index === 0 ? this.product.scheme_card_additional_driver_one_heading_text : this.product.scheme_card_additional_driver_two_heading_text;
            } else {
                return !this.profile.additionalDrivers || this.profile.additionalDrivers.length === 0 ? this.product.scheme_card_additional_driver_one_heading_text : this.product.scheme_card_additional_driver_two_heading_text;
            }
        },
        maxAdditionalDrivers() {
            return parseInt(this.product.maximum_additional_drivers);
        },
    },

    methods: {
        changePrimaryOvernightVehicleLocation(value) {
            EventBus.$emit('loadingTitle', 'Updating Primary Overnight Vehicle Location');
            EventBus.$emit('loading', true);

            this.$http.post('/api/update-primary-overnight-vehicle-location', {
                'primaryOvernightVehicleLocation': value
                })
                .then(response => {
                    EventBus.$emit('loading', false);

                    this.$notify({
                        group: 'notify',
                        type: 'success',
                        title: 'Success',
                        text: 'Primary Overnight Vehicle Location saved successfully'
                    });

                    EventBus.$emit('yourProfileCompleted', response.data.profileCompleted);
                    EventBus.$emit('reload-driver-profile');
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response.data;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.error.message
                    });
                });
        },

        toggleAcceptanceOfSalarySacrificeConditionsOfUseAndInsurance(event) {

            EventBus.$emit('loadingTitle', 'Updating Acceptance of Salary Sacrifice Conditions of Use and Insurance');
            EventBus.$emit('loading', true);

            this.$http.post('/api/update-acceptance-of-salary-sacrifice-conditions-of-use-and-insurance', {
                'acceptanceOfSalarySacrificeConditionsOfUseAndInsurance': event.target.checked
                })
                .then(response => {
                    EventBus.$emit('loading', false);

                    this.$notify({
                        group: 'notify',
                        type: 'success',
                        title: 'Success',
                        text: 'Acceptance saved successfully'
                    });

                    EventBus.$emit('yourProfileCompleted', response.data.profileCompleted);
                    EventBus.$emit('reload-driver-profile');
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response.data;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.error.message
                    });
                });
        },

        showSlideout() {
            this.slideoutVisible = true;
        },

        hideSlideout() {
            this.slideoutVisible = false;
        },

        getPrimaryOvernightVehicleLocationOptionsAndSetSelected() {
            this.primaryOvernightVehicleLocation.options = [];

            this.primaryOvernightVehicleLocation.options.push(this.profile.postcode);

            if (this.profile.additionalDrivers) {
                this.profile.additionalDrivers.forEach(additionalDriver => {
                    if (!this.primaryOvernightVehicleLocation.options.includes(additionalDriver.postcode)) {
                        this.primaryOvernightVehicleLocation.options.push(additionalDriver.postcode);
                    }
                });
            }

            this.primaryOvernightVehicleLocation.options.sort();
            this.primaryOvernightVehicleLocation.selected = this.profile.primaryOvernightVehicleLocation;
        },

        showNewAdditionalDriverForm() {
            this.payload = {
                additionalDriverID: null,
                firstname: null,
                surname: null,
                email: null,
                mainDriver: null,
                postcode: null,
                dob: this.getDateOfBirth(),
                drivingLicense: null,
                insuranceQuestions: {
                    'Is the driver a permanent UK resident': null,
                    'Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document': null,
                    'Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS': null,
                    'Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT': null,
                    'Has the driver received any conviction which has resulted in a driving ban in the last 5 years': null,
                    'Has the driver had more than 1 FAULT claim in the last 3 years': null
                },
                scheme: 'salsac',
            }

            this.showSlideout();
        },

        showExistingAdditionalDriverForm(index) {
            const additionalDriver = this.profile.additionalDrivers[index];

            if (additionalDriver) {
                this.payload = {
                    additionalDriverID: additionalDriver.id,
                    firstname: additionalDriver.forename,
                    surname: additionalDriver.surname,
                    email: additionalDriver.emailAddress,
                    mainDriver: Boolean(additionalDriver.mainDriver),
                    postcode: additionalDriver.postcode,
                    dob: this.getDateOfBirth(additionalDriver.dateOfBirth),
                    drivingLicense: additionalDriver.driverLicence.licenceNumber,
                    insuranceQuestions: {
                        'Is the driver a permanent UK resident': (additionalDriver?.insuranceQuestions?.['Is the driver a permanent UK resident']),
                        'Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document': (additionalDriver?.insuranceQuestions?.['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']),
                        'Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS': (additionalDriver?.insuranceQuestions?.['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']),
                        'Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT': (additionalDriver?.insuranceQuestions?.['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']),
                        'Has the driver received any conviction which has resulted in a driving ban in the last 5 years': (additionalDriver?.insuranceQuestions?.['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']),
                        'Has the driver had more than 1 FAULT claim in the last 3 years': (additionalDriver?.insuranceQuestions?.['Has the driver had more than 1 FAULT claim in the last 3 years'])
                    },
                    scheme: 'salsac',
                }

                this.showSlideout();
            }
        },

        submitAdditionalDriverForm() {

            if (this.payload.dob.year === new Date().getUTCFullYear()) {
                alert('Please ensure the Date of Birth field is configured correctly.')
                return;
            }

            EventBus.$emit('loading', true);
            let interval = 1000;
            let messages = [
                'Saving Additional Driver',
                'Recalculating quotes',
            ];
            messages.forEach((message, index) => {
                setTimeout(() => {
                    EventBus.$emit('loadingTitle', message);
                }, index * interval);
            });

            this.$http.post('/api/save-additional-driver', this.payload)
                .then(response => {
                    EventBus.$emit('loading', false);

                    this.$notify({
                        group: 'notify',
                        type: 'success',
                        title: 'Success',
                        text: 'Additional Driver saved successfully'
                    });

                    this.payload.additionalDriverID = response.data.data.id;

                    this.hideSlideout();

                    EventBus.$emit('reload-driver-profile');
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response.data;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.error.message
                    });
                });
        },

        getDateOfBirth(dateOfBirth=null) {
            const dob = dateOfBirth ? new Date(dateOfBirth) : new Date();

            return {
                month: months[parseInt(dob.getMonth())],
                day: dob.getDate(),
                year: dob.getFullYear()
            };
        },

        years() {
            const now = new Date().getUTCFullYear();
            const years = Array(now - (now - 80)).fill('').map((v, idx) => now - idx);
            return years;
        },

        daysInMonth(month, year) {
            const monthInt = this.months.indexOf(month) + 1;
            const totalDays = new Date(year, monthInt, 0).getDate();
            const days = [];

            let day = 1;

            while (day <= totalDays) {
                days.push(day++);
            }

            return days;
        },

        formatIsoDate(isoDate) {
            let formattedDate = '';

            if (isoDate) {
                formattedDate = new Date(isoDate).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
            }

            return formattedDate;
        },

        driverLicense(driver) {
            return driver.driverLicence?.licenceNumber;
        },

        editProfile() {
            EventBus.$emit('editProfile');
        },

        deleteAdditionalDriver() {
            EventBus.$emit('loading', true);
            let interval = 1000;
            let messages = [
                'Deleting Additional Driver',
                'Recalculating quotes',
            ];
            messages.forEach((message, index) => {
                setTimeout(() => {
                    EventBus.$emit('loadingTitle', message);
                }, index * interval);
            });

            this.$http.post('/api/delete-additional-driver', this.payload)
                .then(response => {
                    EventBus.$emit('loading', false);

                    this.$notify({
                        group: 'notify',
                        type: 'success',
                        title: 'Success',
                        text: 'Additional Driver deleted successfully'
                    });

                    this.payload.additionalDriverID = null;

                    this.hideSlideout();

                    EventBus.$emit('reload-driver-profile');
                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response.data;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.error.message
                    });
                });
        },

        invalidInsuranceQuestionAnswers(insuranceQuestionAnswers) {

            if (!insuranceQuestionAnswers) return true;

            return (
                insuranceQuestionAnswers['Is the driver a permanent UK resident'] !== 'Yes'
                || insuranceQuestionAnswers['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] !== 'Yes'
                || insuranceQuestionAnswers['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] !== 'No'
                || insuranceQuestionAnswers['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] !== 'No'
                || insuranceQuestionAnswers['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] !== 'No'
                || insuranceQuestionAnswers['Has the driver had more than 1 FAULT claim in the last 3 years'] !== 'No'
                || !insuranceQuestionAnswers['Is the driver a permanent UK resident']
                || !insuranceQuestionAnswers['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document']
                || !insuranceQuestionAnswers['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS']
                || !insuranceQuestionAnswers['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT']
                || !insuranceQuestionAnswers['Has the driver received any conviction which has resulted in a driving ban in the last 5 years']
                || !insuranceQuestionAnswers['Has the driver had more than 1 FAULT claim in the last 3 years']
            );
        },
    },

    props: [
        'profile',
        'product',
    ],

    components: {
        Multiselect
    },

}
</script>

